import { displayToastError, http } from 'app';
import { IGetEmailSummary, IPutData } from 'app/utils';

export const getFileExtraction = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response.data.statusCode === 422) {
      const newBody = body;
      newBody.set('ignoreCache', true);
      try {
        const response = await http.post(
          '/:businessArea/:service'
            .replace(':businessArea', businessArea)
            .replace(':service', service),
          newBody,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        return response.data;
      } catch (error: any) {
        const errorMessage = error.response.data.message;
        displayToastError(String(errorMessage), 'Get Extraction');
      }
    } else {
      const errorMessage = error.response.data.message;
      displayToastError(String(errorMessage), 'Get Extraction');
    }
  }
};

export const getEmailSummary = async (
  businessArea: string,
  service: string,
  body: IGetEmailSummary
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Get Extraction');
  }
};

export const updateExtraction = async (
  businessArea: string,
  service: string,
  body: IPutData
): Promise<any> => {
  try {
    const response = await http.put(
      '/:businessArea/:service'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Update Fields');
  }
};

export const getTranslatedFields = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/translate'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Error on translate');
  }
};

export const getTranslatedText = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/translate'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Error while translating text');
  }
};

export const getAvailableTextTranslatorLanguages = async (
  businessArea: string,
  service: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/available-languages'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(
      String(errorMessage),
      'Error while getting available languages'
    );
  }
};

export const getTranslatorBootstrap = async (
  businessArea: string,
  service: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/bootstrap'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(
      String(errorMessage),
      'Error while getting translator bootstrap data'
    );
  }
};

export const uploadTranslationFile = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/document/upload'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(
      String(errorMessage),
      'Error while uploading translation file'
    );
  }
};

export const getTranslationStatus = async (
  businessArea: string,
  service: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/document/status'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(
      String(errorMessage),
      'Error while getting translation status'
    );
    throw error;
  }
};

export const getTranslatedFile = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/document/download'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(
      String(errorMessage),
      'Error while getting translated file'
    );
  }
};

export const getAvailableFileTranslatorLanguages = async (
  businessArea: string,
  service: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/document/available-languages'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(
      String(errorMessage),
      'Error while getting file translator available languages'
    );
  }
};

export const getCoverageCheck = async (
  businessArea: string,
  service: string,
  body: any,
  step: string
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/steps/:step'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
        .replace(':step', step),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Coverage Check');
  }
};

export const getCallRetentionExtraction = async (
  businessArea: string,
  service: string,
  executionId: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/:executionId'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
        .replace(':executionId', executionId)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Get Call Retention analysis');
  }
};

export const compareDocuments = async (
  businessArea: string,
  service: string,
  body: any
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Error while translating text');
  }
};
